import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CheckBook } from '../../models/check-book';
import { FactorPayment } from '../../models/factor-paymnet';
import { NumericService } from 'src/app/services/numeric.service';

@Component({
  selector: 'app-cash-pay',
  templateUrl: './cash-pay.component.html',
  styleUrls: ['./cash-pay.component.css'],
})
export class CashPayComponent implements OnChanges {
  public constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    private modalService: NgbModal,
    public numericService: NumericService
  ) {}

  @ViewChild('datePicker') popoverDataPicker!: NgbPopover;
  @ViewChild('listPayment') listPaymentElement!: ElementRef;

  @Input() thisItem: any;
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public modalSuccessConfirm: boolean = false;
  public loading: boolean = false;
  public factorMaxValue: string = '0';
  public backendJson = {
    totalPrice: 0,
    description: '',
    paymentType: 1,
    checks: [],
    buyFactories: [
      {
        buyFactorId: '',
      },
    ],
  };

  public checkNumbers: any[] = [
    {
      id: 'current.id',
      name: 'current.name',
      persianName: 'current.persianName',
    },
  ];
  public usablePages: any[] = [
    {
      number: 'current.number',
    },
  ];

  public monthName: string = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['thisItem'] &&
      changes['thisItem'].currentValue !== undefined
    ) {
      const newData = changes['thisItem'].currentValue;

      if (newData) {
        this.backendJson.totalPrice = newData.totalPrice;
        this.factorMaxValue = newData.totalPrice;
        this.backendJson.buyFactories[0].buyFactorId = newData.id;
      }
    }
  }

  public callParent(method: string) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, undefined));
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
    }
  }

  public savePaymentInfo() {
    try {
      this.loading = true;

      let url = `Payment/PaymentImport`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalService.dismissAll();
              this.modalSuccessConfirm = true;
            } else {
              this.logger.addListError(result.errorMessages);
            }
            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkPayValue() {
    const trueValue = this.numericService.checkMax(
      this.factorMaxValue,
      this.backendJson.totalPrice
    );

    this.backendJson.totalPrice=parseInt(trueValue, 10);
  }
}
